export const FETCH_CONVERSATION = 'FETCH_CONVERSATION';
export const FETCH_CONVERSATION_FULFILLED = 'FETCH_CONVERSATION_FULFILLED';
export const FETCH_CONVERSATION_REJECTED = 'FETCH_CONVERSATION_REJECTED';
export const ADD_CONVERSATION_REJECTED = 'ADD_CONVERSATION_REJECTED';
